import { useEffect } from 'react';

const SITE_NAME = 'YourNest Venture Capital';

/**
 * Sets document.title for the current route (WCAG 2.4.2).
 * @param {string} title - Page-specific title (without site suffix)
 */
export function usePageTitle(title) {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    return () => {
      document.title = previous;
    };
  }, [title]);
}

export default usePageTitle;
